import { render, staticRenderFns } from "./ConsultarAdmision.vue?vue&type=template&id=7b040e18&scoped=true"
import script from "./ConsultarAdmision.vue?vue&type=script&lang=js"
export * from "./ConsultarAdmision.vue?vue&type=script&lang=js"
import style0 from "./ConsultarAdmision.vue?vue&type=style&index=0&id=7b040e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b040e18",
  null
  
)

export default component.exports